import Button from '../../../../../component/ui/Button';
import { hasPermission } from '../../../../../utils/controller';

const CreateSalesReturnHeader = ({
	id,
	loading,
	user,
	paymentMethodList,
	navigate,
	salesReturn,
	suburl,
	setIsSalesReturnAutoSave,
	setIsCreateCreditNote,
	handleSubmitSalesReturn,
}) => {
	return (
		<div className="header-position-sticky">
			<div className="product-pg-header">
				<p>
					{id ? 'Update ' : 'Create New '}
					Sales Return
				</p>
				<div className="add-product-button">
					<Button
						type="button"
						className="btn-primary mt-0 px-4"
						button={id ? 'Update' : 'Save'}
						loader={loading}
						disabled={
							loading ||
							(id
								? !hasPermission('sales.sales_return.edit', user?.role?.role_permissions)
								: !hasPermission('sales.sales_return.create', user?.role?.role_permissions))
						}
						onClick={() => {
							var list = paymentMethodList.filter(
								(item) =>
									item.key === salesReturn.payment_method &&
									item.value.toLowerCase().includes('credit'),
							);

							if (list.length > 0 && !id) {
								setIsSalesReturnAutoSave(false);
								setIsCreateCreditNote(true);
							} else {
								setIsSalesReturnAutoSave(false);
								handleSubmitSalesReturn(1);
							}
						}}
					/>
					<Button
						type="button"
						className="mt-0 btn-danger add-pro"
						button=""
						close
						onClick={() => navigate(`/user/${suburl}/sales-return`)}
					/>
				</div>
			</div>
		</div>
	);
};
export default CreateSalesReturnHeader;
